import * as React from "react";
import ViewPanel, { ViewType } from "../ViewPanel";
import { Container } from "./styled";
import PlaceFreeManagement from "./place-free-management";
import AdditionalInformationManagement from "./additional-information-management";
import ApprovalNotificationManagement from "./approval-notification-management/approval-notification-management";
import PcInfoSection from "../pc-info-section/pc-info-section";
import WorkViewSection from "../work-view-section/work-view-section";
import CommuteViewSection from "../commute-view-section/commute-view-section";
import styled from "styled-components";
import WorkTimeInformation from "../../../../screens/work-management-info/employee-info-detail/work-time-info/work_time_information";
import WorkingTemplate from "./working_template/working_template";
import AnnualStatus from "./annual_status/annual_status";
import ApprovalStatus from "./approval_status/approval_status";

type Props = {
  viewType: ViewType;
};

const ContentContainer = styled.div`
  display: flex;
  flex: 8;
  overflow-x: auto;
  > div {
    width: 0px;
  }
`;

const DetailView = <P extends Props>(props: P) => {
  const { viewType } = props;

  const handleComponent = React.useCallback(() => {
    let RenderComponent;
    switch (viewType) {
      case ViewType.WORKING_TEMPLATE:
        // 근무제정보
        RenderComponent = WorkingTemplate;
        break;
      case ViewType.PC:
        // PC정보
        RenderComponent = PcInfoSection;
        break;
      case ViewType.WORK_MANAGEMENT:
        //근무관리정보
        RenderComponent = WorkViewSection;
        break;
      case ViewType.COMMUTE:
        // 출퇴근관리정보
        RenderComponent = CommuteViewSection;
        break;
      case ViewType.PLACE_FREE_MANAGEMENT:
        // 이석관리
        RenderComponent = PlaceFreeManagement;
        break;
      case ViewType.ADDITIONAL_INFORMATION_MANAGEMENT:
        // 추가정보관리
        RenderComponent = AdditionalInformationManagement;
        break;
      case ViewType.APPROVAL_NOTIFICATION:
        // 결재알림관리
        RenderComponent = ApprovalNotificationManagement;
        break;
      case ViewType.WORK_TIME_INFORMATION:
        // 근무시간정보
        RenderComponent = WorkTimeInformation;
        break;
      case ViewType.ANNUAL_STATUS:
        // 연차현황
        RenderComponent = AnnualStatus;
        break;
      case ViewType.APPROVAL_STATUS:
        // 결재현황
        RenderComponent = ApprovalStatus;
        break;
      default:
        RenderComponent = PcInfoSection;
    }
    return RenderComponent;
  }, [viewType]);

  const RenderComponent = React.useMemo(handleComponent, [handleComponent]);

  return (
    <Container>
      <ViewPanel />
      <ContentContainer>
        <RenderComponent />
      </ContentContainer>
    </Container>
  );
};

export default DetailView;
